"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var AWSCognitoConstants_1 = require("./AWSCognitoConstants");
var Utils_1 = require("./Utils");
var BrowserService_1 = require("./BrowserService");
var axios_1 = require("axios");
var LOG_POSTING_INTERVAL_IN_MILLI_SEC = 30000;
var MAX_LOG_DELIVERY_ATTEMPT_NUM = 2;
var isDevEnvironment = Utils_1.default.isDevEnvironment;
var GB_TOKEN = 'gb_access_token';
var GB_EXP = 'gb_access_token_exp';
var LOGGING_TOKEN = 'lds_token';
var LOGGING_TOKEN_EXPIRATION = 'lds_token_expiration';
var LOGGING_TOKEN_AUTH = 'lds_authentication';
var LOGGING_BASE_URL = 'metrics.amazonworkdocs.com';
var LOCAL_STORAGE_KEY_FAILED_METRICS = "WD_LOG_RECORDS_FAILED2";
var LoggingService = (function () {
    function LoggingService(context, appName, stage, region, sessionId, firehoseConfig, forwardingServiceEnabled, userAgent) {
        if (stage === void 0) { stage = 'ALPHA'; }
        if (userAgent === void 0) { userAgent = "AWSWorkDocsWebClient"; }
        var _this = this;
        this.context = context;
        this.appName = appName;
        this.stage = stage;
        this.region = region;
        this.sessionId = sessionId;
        this.firehoseConfig = firehoseConfig;
        this.forwardingServiceEnabled = forwardingServiceEnabled;
        this.userAgent = userAgent;
        this.logRecordsBuffer = [];
        if (this.firehoseConfig) {
            // Nova manually sends in data stream name. If Config exists, do nothing. 
        }
        else if (!!AWSCognitoConstants_1.DELIVERY_STREAM_NAME[stage] && !!AWSCognitoConstants_1.DELIVERY_STREAM_NAME[stage][region]) {
            this.firehoseConfig = {
                deliveryStreamName: AWSCognitoConstants_1.DELIVERY_STREAM_NAME[stage][region].logStream,
                region: region
            };
        }
        else {
            this.firehoseConfig = {
                deliveryStreamName: "gb-web-metrics-v3",
                region: region
            };
        }
        this.getURL();
        context.addEventListener('beforeunload', function () {
            if (_this.logRecordsBuffer.length > 0) {
                _this.writeLogsToLocalStorage(_this.logRecordsBuffer);
            }
        });
    }
    LoggingService.prototype.getURL = function () {
        switch (this.stage.toLowerCase()) {
            case "dev":
                this.ldsBaseURL = "https://alpha." + LOGGING_BASE_URL;
                break;
            case "alpha":
                this.ldsBaseURL = "https://alpha." + LOGGING_BASE_URL;
                break;
            case "beta":
            case "gamma":
                this.ldsBaseURL = "https://beta." + LOGGING_BASE_URL;
                break;
            default:
                this.ldsBaseURL = "https://" + this.region + "." + LOGGING_BASE_URL;
        }
    };
    LoggingService.prototype.setUserId = function (userId) {
        this.userId = userId;
    };
    LoggingService.prototype.setOrganizationId = function (organizationId) {
        this.organizationId = organizationId;
    };
    LoggingService.prototype.setCommonParam = function (commonParam) {
        this.commonParam = commonParam;
    };
    LoggingService.prototype.destroy = function () {
        if (this.postLogsTimeoutId) {
            clearTimeout(this.postLogsTimeoutId);
            this.postLogsTimeoutId = null;
        }
    };
    LoggingService.prototype.forcePostLogs = function () {
        var _this = this;
        var localStorage = this.context.localStorage;
        if (this.postLogsTimeoutId) {
            clearTimeout(this.postLogsTimeoutId);
            var ret = this.postLogsToServer();
            ret.catch(function () {
                localStorage.setItem(LOCAL_STORAGE_KEY_FAILED_METRICS, JSON.stringify(_this.logRecordsBuffer));
            });
            return ret;
        }
        return Promise.resolve({});
    };
    LoggingService.prototype.getLogsFromLocalStorage = function () {
        var localStorage = this.context.localStorage;
        var existingEntriesString = localStorage.getItem(LOCAL_STORAGE_KEY_FAILED_METRICS);
        var existingEntries = [];
        if (existingEntriesString) {
            try {
                existingEntries = JSON.parse(existingEntriesString);
            }
            catch (e) {
                console.log("error parsing metric log entries");
            }
        }
        return existingEntries;
    };
    LoggingService.prototype.writeLogsToLocalStorage = function (records) {
        // cap the record to 2500 (~1.5mb). for details: https://www.html5rocks.com/en/tutorials/offline/quota-research/
        var localStorage = this.context.localStorage;
        var existingEntries = this.getLogsFromLocalStorage();
        var newEntries = existingEntries.concat(records);
        if (newEntries.length > 2500) {
            newEntries = lodash_1.drop(newEntries, newEntries.length - 2500);
        }
        try {
            localStorage.setItem(LOCAL_STORAGE_KEY_FAILED_METRICS, JSON.stringify(newEntries));
        }
        catch (e) {
            localStorage.removeItem(LOCAL_STORAGE_KEY_FAILED_METRICS);
            console.log("Error writing metrics to local storage");
        }
    };
    LoggingService.prototype.schedulePostLogsToServer = function () {
        var _this = this;
        if (!this.postLogsTimeoutId) {
            this.postLogsTimeoutId = this.context.setTimeout(function () {
                if (_this.logDeliveryPromise) {
                    // if there is a pending promise, yield and make another schedule later.
                    _this.schedulePostLogsToServer();
                }
                else {
                    _this.logDeliveryPromise = _this.postLogsToServer();
                    _this.logDeliveryPromise.then(function () {
                        _this.logDeliveryPromise = null;
                    }, function () {
                        _this.logDeliveryPromise = null;
                    });
                }
            }, LOG_POSTING_INTERVAL_IN_MILLI_SEC);
        }
    };
    LoggingService.prototype.postLogsToServer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var logsToSend, logBatches, failedlogs, discardedLogs, retriableLogs, _loop_1, this_1, _i, logBatches_1, batch, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.postLogsTimeoutId = null;
                        logsToSend = this.logRecordsBuffer.concat(this.getLogsFromLocalStorage());
                        this.context.localStorage.removeItem(LOCAL_STORAGE_KEY_FAILED_METRICS);
                        this.logRecordsBuffer = [];
                        logBatches = lodash_1.chunk(logsToSend, 500);
                        failedlogs = [];
                        discardedLogs = [];
                        retriableLogs = [];
                        _loop_1 = function (batch) {
                            var batchPrep, putLogResponse_1, failedEntryIndexes, error_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        batchPrep = batch.map(function (record) {
                                            var recordCopy = __assign({}, record);
                                            delete recordCopy.deliverAttemptCount;
                                            // Add "log" wrapper to the data for the GB stream (assume they all start with "gb-web-metrics") to make it backward compatible
                                            // need to add "\n" for Athena consumption because https://stackoverflow.com/questions/48226472/kinesis-firehose-putting-json-objects-in-s3-without-seperator-comma
                                            if (_this.firehoseConfig.deliveryStreamName.indexOf('gb-web-metrics') === 0) {
                                                return {
                                                    Data: JSON.stringify({
                                                        log: recordCopy
                                                    }) + '\n'
                                                };
                                            }
                                            else {
                                                return {
                                                    Data: JSON.stringify(recordCopy) + '\n'
                                                };
                                            }
                                        });
                                        return [4 /*yield*/, this_1.ldsPostLoggingService(batchPrep, this_1.firehoseConfig.deliveryStreamName)];
                                    case 1:
                                        putLogResponse_1 = _a.sent();
                                        if (putLogResponse_1.FailedPutCount > 0) {
                                            failedEntryIndexes = putLogResponse_1.RequestResponses.map(function (result, index) { return !!result.ErrorCode ? index : -1; }).filter(function (index) { return index !== -1; });
                                            failedEntryIndexes.forEach(function (index) {
                                                batch[index].deliverAttemptCount++;
                                                failedlogs.push(batch[index]);
                                                _this.error('put log failed because: ' + putLogResponse_1.RequestResponses[index].ErrorMessage);
                                            });
                                        }
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_1 = _a.sent();
                                        batch.forEach(function (entry) {
                                            entry.deliverAttemptCount++;
                                            failedlogs.push(entry);
                                        });
                                        this_1.error('put log batch failed because: ' + JSON.stringify(error_1));
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _i = 0, logBatches_1 = logBatches;
                        _b.label = 1;
                    case 1:
                        if (!(_i < logBatches_1.length)) return [3 /*break*/, 4];
                        batch = logBatches_1[_i];
                        return [5 /*yield**/, _loop_1(batch)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        _a = lodash_1.partition(failedlogs, function (entry) {
                            return entry.deliverAttemptCount < MAX_LOG_DELIVERY_ATTEMPT_NUM;
                        }), retriableLogs = _a[0], discardedLogs = _a[1];
                        if (retriableLogs.length > 0 || discardedLogs.length > 0) {
                            this.writeLogsToLocalStorage(retriableLogs);
                            throw new Error("SUCCEEDED_WITH_ERROR");
                        }
                        else {
                            return [2 /*return*/, "SUCCEEDED"];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LoggingService.prototype.constructBaseLogRecord = function () {
        return __assign({ AppName: this.appName, PageUrl: this.context.location.pathname + this.context.location.hash, SessionId: this.sessionId, Stage: this.stage, Region: this.region, OrganizationId: this.organizationId, UserId: this.userId, Timestamp: new Date(), OSName: BrowserService_1.default.getOS(), OSVersion: BrowserService_1.default.getOSVersion(), Browser: BrowserService_1.default.getBrowser(), BrowserVersion: BrowserService_1.default.getBrowserVersion(), deliverAttemptCount: 0 }, this.commonParam);
    };
    LoggingService.prototype.constructLogRecord = function (message, level, error) {
        var errorInfo = {};
        if (level === 'error' && !!error) {
            errorInfo.ErrorMessage = error.message;
            errorInfo.ErrorStack = error.stack;
            if (!!lodash_1.get(error, 'response.data')) {
                errorInfo.ErrorMessage += 'data: ' + lodash_1.get(error, 'response.data');
            }
        }
        return __assign({}, this.constructBaseLogRecord(), errorInfo, { Event: "LOG_" + level.toUpperCase(), Metadata: message });
    };
    LoggingService.prototype.logInternal = function (level, message, error) {
        if (typeof window !== 'undefined' && isDevEnvironment(this.context)) {
            console[level].apply(console, [message]);
        }
        else {
            this.logRecordsBuffer.push(this.constructLogRecord(message, level, error));
            this.schedulePostLogsToServer();
        }
    };
    LoggingService.prototype.ldsPostLoggingService = function (_logs, _deliveryStreamName) {
        return __awaiter(this, void 0, void 0, function () {
            var localStorage, config, gbToken, gbExpiration, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localStorage = this.context.localStorage;
                        return [4 /*yield*/, this.ldsForwardLogsReady()];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.ldsForwardPostRequest(_logs, _deliveryStreamName)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        config = void 0;
                        if (this.stage.toLowerCase() === "prod") {
                            gbToken = localStorage.getItem(GB_TOKEN);
                            gbExpiration = localStorage.getItem(GB_EXP);
                            config = {
                                headers: {
                                    "x-amz-security-token": gbToken && new Date(gbExpiration) > new Date() ? gbToken : null,
                                    "x-amz-user-agent": this.userAgent
                                }
                            };
                        }
                        else {
                            config = {
                                headers: {
                                    "x-amz-security-token": null,
                                    "x-amz-user-agent": this.userAgent
                                }
                            };
                        }
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 9, , 10]);
                        return [4 /*yield*/, axios_1.default.get(this.ldsBaseURL + "/api/v1/logs/token", config)];
                    case 5:
                        response = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 7];
                        localStorage.setItem(LOGGING_TOKEN, response.data.Token);
                        localStorage.setItem(LOGGING_TOKEN_EXPIRATION, response.data.TokenExpirationUtc);
                        localStorage.setItem(LOGGING_TOKEN_AUTH, String(!!localStorage.getItem(GB_TOKEN)));
                        return [4 /*yield*/, this.ldsForwardPostRequest(_logs, _deliveryStreamName)];
                    case 6: return [2 /*return*/, _a.sent()];
                    case 7: throw new Error("Issue with getting token \n Error: " + response);
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        error_2 = _a.sent();
                        throw error_2;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    LoggingService.prototype.ldsForwardLogsReady = function () {
        var localStorage = this.context.localStorage;
        var ldsExpiration = localStorage.getItem(LOGGING_TOKEN_EXPIRATION);
        var ldsToken = localStorage.getItem(LOGGING_TOKEN);
        var gbToken = localStorage.getItem(GB_TOKEN);
        var ldsAuth = localStorage.getItem(LOGGING_TOKEN_AUTH);
        if (ldsAuth === "true" && !!ldsToken && new Date() < new Date(ldsExpiration)) {
            return true;
        }
        else if (!gbToken && !!ldsToken && new Date() < new Date(ldsExpiration)) {
            return true;
        }
        else {
            return false;
        }
    };
    LoggingService.prototype.ldsForwardPostRequest = function (Logs, deliveryStreamName) {
        return __awaiter(this, void 0, void 0, function () {
            var localStorage, request, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localStorage = this.context.localStorage;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        request = {
                            Logs: Logs,
                            StreamName: deliveryStreamName
                        };
                        return [4 /*yield*/, axios_1.default.post(this.ldsBaseURL + "/api/v1/logs/uploadtofirehose", JSON.stringify(request), {
                                headers: {
                                    "x-amz-security-token": localStorage.getItem(LOGGING_TOKEN),
                                    "x-amz-user-agent": this.userAgent
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status !== 200)
                            throw new Error(String(response.data));
                        return [2 /*return*/, response.data];
                    case 3:
                        error_3 = _a.sent();
                        return [2 /*return*/, error_3];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LoggingService.prototype.log = function (record) {
        if (typeof window !== 'undefined' && isDevEnvironment(this.context)) {
            console.log("Record", record);
            return;
        }
        else {
            if (typeof record === 'string') {
                record = {
                    Metadata: record
                };
            }
            this.logRecordsBuffer.push(__assign({}, this.constructBaseLogRecord(), record));
            this.schedulePostLogsToServer();
        }
    };
    LoggingService.prototype.debug = function (message) {
        this.logInternal("debug", message);
    };
    LoggingService.prototype.info = function (message) {
        this.logInternal("info", message);
    };
    LoggingService.prototype.warn = function (message) {
        this.logInternal("warn", message);
    };
    LoggingService.prototype.error = function (message, error) {
        this.logInternal("error", message, error);
    };
    return LoggingService;
}());
exports.default = LoggingService;
